import React, { useState, useEffect, memo } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { resolveImageSrc } from "../../utils/imageHelper";
import configData from "../../../src/config.json";
import "./Birthday.css";

function BirthdayCarousel({ birthday_record }) {
  const [records, setRecords] = useState(birthday_record || []);

  // Birthdays are loaded lazily (paginated, images as URLs) instead of being
  // embedded (base64) in the login payload.
  useEffect(() => {
    let cancelled = false;
    const fetchBirthdays = async () => {
      try {
        const response = await fetch(`${configData.SERVER_URL}/api/birthdays`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            secretKey: configData.SECRET_Key,
            month: new Date().getMonth() + 1,
            limit: 30,
          }),
        });
        const data = await response.json();
        const result = JSON.parse(data.result);
        if (!cancelled && result.success && Array.isArray(result.birthday_record)) {
          setRecords(result.birthday_record);
        }
      } catch (error) {
        console.error("Error fetching birthdays:", error);
      }
    };
    fetchBirthdays();
    return () => {
      cancelled = true;
    };
  }, []);

  const settings = {
    arrows: false,
    dots: false,
    infinite: true, // Allow infinite scrolling even for one item
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable autoplay even for one record
    autoplaySpeed: 2000, // Adjust the speed as needed
    slickPlay: true,
  };

  if (!records || records.length === 0) return null;

  const renderSlide = (record, index) => (
    <div key={index}>
      <div className="slick-item">
        <img
          src={resolveImageSrc(record[0])}
          alt={record[1]}
          loading="lazy"
          className="img-fluid rounded-circle"
          style={{ height: 100, width: 100 }}
        />
        <p
          style={{
            fontSize: 25,
            fontWeight: 500,
            color: "#44444491",
            textAlign: "center",
            marginTop: 22,
            marginBottom: 1,
          }}
        ></p>
        <p
          style={{
            fontFamily: '"Caveat Brush", cursive',
            fontWeight: 400,
            fontStyle: "normal",
            fontSize: 20,
            textAlign: "center",
          }}
        >
          {record[1]}
          <br />
          {record[4] || record[2]}
          <br />
          {record[3]}
        </p>
      </div>
    </div>
  );

  return (
    <>
      <div
        className="mt-3"
        style={{
          padding: "0px 10px",
        }}
      >
        <h4>Birthdays</h4>
      </div>
      <div className="slick-container w-3/4 m-auto">
        <Slider {...settings}>
          {records.length === 1
            ? [renderSlide(records[0], 0), renderSlide(records[0], 0)]
            : records.map((record, index) => renderSlide(record, index))}
        </Slider>
      </div>
    </>
  );
}

export default memo(BirthdayCarousel);
